<template>
  <div id="main">
    <!-- <sm-web-map server-url="https://iportal.supermap.io/iportal/" map-id="801571284"> -->
      <sm-web-map v-if="mapOptions" ref="map" :map-options="mapOptions" style="background: black" @load="load">
        <sm-animate-marker-layer :features="features" type="rotatingTextBorder" text-field="NAME" :colors="['rgb(21, 209, 242)', 'rgba(21, 209, 242, 0.56)']" :width="150" :fit-bounds="false"></sm-animate-marker-layer>
      </sm-web-map>
  </div>
</template>

<script>
import { indexCenter } from '@/api/indexCenter';
import { dataInterface } from '@/api/dataInterfaceApi';
var mapUrl = 'https://iserver.supermap.io/iserver/services/map-china400/rest/maps/ChinaDark';
mapboxgl.accessToken = 'pk.eyJ1IjoiY2FydG9kYmluYyIsImEiOiJja202bHN2OXMwcGYzMnFrbmNkMzVwMG5rIn0.Zb3J4JTdJS-oYNXlR3nvnQ';
import area_diamond from '@/assets/images/index/area_diamond.png';
import area_diamond2 from '@/assets/images/index/area_diamond2.png';
import car_bg from '@/assets/images/index/car_bg.png';
export default {
  data() {
    return {
      mapOptions: null,
      Options: {
        container: 'map', // container id
        style: {
          version: 8,
          sources: {
            composite: {
              url: 'mapbox://mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2',
              type: 'vector',
            },
            // 'raster-tiles': {
            //   type: 'raster',
            //   // tiles: [mapUrl + '/zxyTileImage.png?z={z}&x={x}&y={y}'],
            //   tiles: ['https://i.loli.net/2021/09/24/NbY4P8IrkWjC9Hx.png'],//地图背景，替换为背景图片
            //   tileSize: 256,
            // },
          },
          layers: [
            // {
            //   id: 'simple-tiles',
            //   type: 'raster',
            //   source: 'raster-tiles',
            //   minzoom: 0,
            //   maxzoom: 22,
            // },
            // {
            //   id: '3d-buildings',
            //   source: 'composite',
            //   'source-layer': 'building',
            //   filter: ['==', 'extrude', 'true'],
            //   type: 'fill-extrusion',
            //   minzoom: 1,
            //   paint: {
            //     'fill-extrusion-color': [
            //       'case',
            //       ['<', ['get', 'height'], 1],
            //       '#fbb03b',
            //       ['<', ['get', 'height'], 2],
            //       '#223b53',
            //       ['<', ['get', 'height'], 4],
            //       '#15D1F2',
            //       ['<', ['get', 'height'], 8],
            //       '#15D1F2',
            //       '#3bb2d0',
            //     ],
            //     'fill-extrusion-height': ['*', ['get', 'height'], 5],
            //     'fill-extrusion-opacity': 0.6,
            //   },
            // },
          ],
          stationList:[],//站点列表
        },
        // center: [116.45678770471238, 39.91985987899349],
        zoom: 15,
        bearing: 0.8568,
        pitch: 60,
      },
      features: {
      },
      area_diamond:area_diamond,
      popup:'',
      stationList: null,
    };
  },
  components: {

  },
  props:{
    adcode: {
      type: String,
      default: () => ({})
    },
  },
  watch:{
    adcode: {
      handler (newData,oldData) {
        if(newData){
          this.selectDistrictStationInfo(newData);
        }
      },
      immediate: true,
      deep: true
    },
  },
  created () {
    window.popClick = this.popClick;
  },
  mounted () {
    // this.selectDistrictStationInfo(Map);
  },
  methods: {
    popClick(curStationId){
      console.log(curStationId)
      //query-路由传参
      if(window.location.href.indexOf('/pc')>-1){
        this.$router.push({
          path: '/pcsingleSite',
          query: {
            stationId: curStationId
          }
        })
      } else {
        this.$router.push({
          path: '/singleSite',
          query: {
            stationId: curStationId
          }
        })
      }
      
    },
    load(Map){
      this.addMarkerToMap(Map);
      Map.map.addLayer({
        id: '3d-buildings',
        source: 'composite',
        'source-layer': 'building',
        filter: ['==', 'extrude', 'true'],
        type: 'fill-extrusion',
        minzoom: 1,
        paint: {
          'fill-extrusion-color': [
            'case',
            ['<', ['get', 'height'], 1],
            '#fbb03b',
            ['<', ['get', 'height'], 2],
            '#223b53',
            ['<', ['get', 'height'], 4],
            '#15D1F2',
            ['<', ['get', 'height'], 8],
            '#15D1F2',
            '#3bb2d0',
          ],
          'fill-extrusion-height': ['*', ['get', 'height'], 5],
          // 'fill-extrusion-base': 0,
          'fill-extrusion-opacity': 0.6,
        },
      });
      // this.selectDistrictStationInfo(Map);
      // Map.map.on('click', (e) => {
      //     console.log('click',e)
      //       var target = e.originalEvent.target;
      //       if (target.className === 'sm-component-animate-marker__text') {
              
      //           let currentStation = '';//当前点击站点
      //           let curStationId = '';
      //           currentStation = _this.stationList.filter(item=>item.stationName==target.innerText);
      //           curStationId = currentStation[0].id;

      //           //query-路由传参
      //           // this.$router.push({
      //           //   path: '/singleSite',
      //           //   query: {
      //           //     stationId: curStationId
      //           //   }
      //           // })

      //       }
      // });
    },
    // getData(){
    //   this.selectDistrictStationInfo();
    // },
    selectDistrictStationInfo(Map){
      let _this = this;
      let params = {
					"enCode":"TiDB-zhandian-zhandianjingweidu",//TiDB-全国地图
          "@province":_this.adcode
				}
        dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(_this.adcode=='110101'){
            _this.Options.center =  [res[5].longitude,res[5].latitude];
          } else {
            _this.Options.center =  [res[0].longitude,res[0].latitude];
          }
          this.stationList = res || [];
          console.log("🚀 ~ file: superMap.vue ~ line 153 ~ .then ~ _this.Options", _this.Options)
          _this.mapOptions = _this.Options;
          // if(!res&&res.length<=0) return;
          // _this.stationList = res||[];
          
          // _this.mapOptions.center =  [res[0].longitude,res[0].latitude];
          
        })
      .catch((err) => {
        console.log(err);
      });
    },
    addMarkerToMap(Map) {
      this.features = {
        "type": "FeatureCollection",
        "features":[]
      }
      for(let i=0;i<this.stationList.length;i++){
        const item = this.stationList[i];
          let obj = {
            "type": "Feature",
            "properties": {
              "SMID": "1",
              "NAME": item.stationName
            },
            "geometry": { "type": "Point", "coordinates": [item.longitude, item.latitude] },
            "id": 1
          };
          this.features.features.push(obj);
          //创建add Marker
          const el = document.createElement('div');
          el.className = 'marker';

          let marker = new mapboxgl.Marker(el)
          .setLngLat(obj.geometry.coordinates)
          .setPopup(
            this.popup = new mapboxgl.Popup({ offset: 30 }) // add popups
              .setHTML(
                `
                <div class="pop-content flex flex-direction" onclick="popClick('${item.id}')">
                  <div class="text-xsss text-left">${item.stationName}</div>
                  <div class="pop-img flex align-center justifu-center"><img src="${car_bg}"/></div>
                  <div class="text-xsss">可换${item.houseTotalBatteries||0}，排队${item.lineUpNum||0}</div>
                </div>
                <div class="diamand">
                  <img class="diamand1" src="${area_diamond}"/>
                  <img class="diamand2" src="${area_diamond2}"/>
                </div>
                `
              )
          )
          .addTo(Map.map);
          if(i==0){
            marker.togglePopup();
          }
      }
    }
  }
}
</script>
<style lang="scss">
  #main {
    margin: 0 auto;
    width: 100%;
    height: 100%;
  }
  .sm-component-animate-marker__text{
    cursor: pointer;
  }
  .marker {
    // background-image: url('mapbox-icon.png');
    background-size: cover;
    width: 165px;
    height: 45px;
    cursor: pointer;
    z-index: 1000;
    }
    .mapboxgl-popup {
    max-width: 200px;
    }
    .mapboxgl-popup-content {
    //气泡内容部分
    left: 50%;
    text-align: center;
    background:transparent;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
  .mapboxgl-popup-tip{
    border:0;
  }
  .mapboxgl-popup-close-button{
    display:none;
  }
  .pop-content{
    background:url('~@/assets/images/index/area_bg.png');
    width:222px;
    height:184px;
    background-size:100% 100%;
    padding: 5px 15px;
    cursor: pointer;
    .pop-img{
      flex:1;
      padding:5px 0;
      img{
        width:100%;
        border:1px solid rgba(120, 250, 255, 0.43);
      }
    }
  }
  .diamand{
    margin-top:20px;
    margin-bottom:20px;
    // margin-left:20%;
    position:relative;
    .diamand2{
      width:60px;
      height:36px;
      position:absolute;
      bottom: -30px;
      left: 36%;
    }
    .diamand1{
      width:46px;
      height:52px;
      animation: bounce-down 1.5s linear infinite;
    }
  }
  @keyframes bounce-down {
    25% {transform: translateY(-10px);}
    50%, 100% {transform: translateY(0);}
    75% {transform: translateY(10px);}
  }
</style>
